import { resolveCrackmapOverviewWmts } from '../crackmaps/crackmapCatalog';
import { resolveLineConditionOverviewWmts } from '../lineConditions/lineConditionCatalog';
import { resolvePas2161OverviewGrid } from '../pas2161/resolvePas2161OverviewGrid';
import { resolvePotholeOverviewWmts } from '../potholes/potholeCatalog';
import type { DefectOverviewGridConfig } from './overviewGrid';

/** Resolves overview grid config for a defect overlay source layer id. */
export function resolveDefectOverviewGrid(
  sourceLayerId: string | null | undefined,
): DefectOverviewGridConfig | null {
  return (
    resolvePas2161OverviewGrid(sourceLayerId) ??
    resolveCrackmapOverviewWmts(sourceLayerId) ??
    resolvePotholeOverviewWmts(sourceLayerId) ??
    resolveLineConditionOverviewWmts(sourceLayerId)
  );
}
